import { Boxes } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-background" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-6 py-12 md:grid-cols-4">
        <div>
          <div className="flex items-center gap-2.5">
            <div className="flex h-9 w-9 items-center justify-center bg-foreground text-background">
              <Boxes className="h-5 w-5" strokeWidth={2.5} />
            </div>
            <div className="font-display text-base font-extrabold">GROWTHINK</div>
          </div>
          <p className="mt-4 max-w-xs text-sm text-muted-foreground">
            A decentralised AI-powered educational operating system. Verifiable
            learning identities, immutable credentials, lifelong skills.
          </p>
        </div>
        <div>
          <div className="mono text-[10px] uppercase tracking-widest text-muted-foreground">
            Platform
          </div>
          <ul className="mt-3 space-y-2 text-sm">
            <li>Course Catalogue</li>
            <li>Blockchain Certificates</li>
            <li>AI Tutor</li>
            <li>Skills Passport</li>
          </ul>
        </div>
        <div>
          <div className="mono text-[10px] uppercase tracking-widest text-muted-foreground">
            For Roles
          </div>
          <ul className="mt-3 space-y-2 text-sm">
            <li>Students</li>
            <li>Teachers</li>
            <li>Administrators</li>
            <li>Employer Verification</li>
          </ul>
        </div>
        <div>
          <div className="mono text-[10px] uppercase tracking-widest text-muted-foreground">
            Network
          </div>
          <ul className="mt-3 space-y-2 text-sm font-mono">
            <li>polygon · simulated</li>
            <li>ipfs · pinata</li>
            <li>did · web3.id</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-3 px-6 py-4 text-xs text-muted-foreground md:flex-row md:items-center">
          <div className="mono uppercase tracking-widest">
            © 2026 Growthink AI-Cademy
          </div>
          <div className="mono uppercase tracking-widest">
            Pan-African Academic Blockchain Network
          </div>
        </div>
      </div>
    </footer>
  );
}
